import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { PriceDisplay } from './PriceDisplay';
import { CheckCircle2, Lock } from 'lucide-react';
export const FinalOffer = () => {
  return <section className="py-24 bg-cream relative overflow-hidden" data-id="element-40">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-41">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-accent-rose/20 blur-3xl" data-id="element-42" />
      </div>

      <div className="max-w-4xl mx-auto px-6" data-id="element-43">
        <FadeIn className="bg-white rounded-[2.5rem] p-8 md:p-12 shadow-2xl border border-white/50 relative overflow-hidden" data-id="element-44">
          {/* Decorative badge */}
          <div className="absolute top-6 right-6 bg-accent-rose text-text-dark text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-45">
            Oferta Especial
          </div>

          <div className="text-center mb-10" data-id="element-46">
            <h2 className="text-4xl md:text-5xl mb-4" data-id="element-47">
              Método Emprendimiento Aesthetic™
            </h2>
            <p className="text-xl text-text-brown/80" data-id="element-48">
              Todo lo que necesitás para empezar hoy mismo.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-10 items-center mb-10" data-id="element-49">
            <div className="space-y-4" data-id="element-50">
              <h3 className="font-bold text-lg mb-4 border-b border-nude pb-2" data-id="element-51">
                Tu inscripción incluye:
              </h3>
              {['Curso completo paso a paso', 'Plantillas Instagram Aesthetic', 'Guía: Primeras 10 clientas', 'Lista de proveedores premium', 'Entrenamiento de mentalidad', 'Recetario de velas rentables', 'Acceso inmediato y de por vida', 'Soporte y comunidad'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-52">
                  <CheckCircle2 className="w-5 h-5 text-accent-rose-deep shrink-0" data-id="element-53" />
                  <span className="text-text-brown font-medium" data-id="element-54">{item}</span>
                </div>)}
            </div>

            <div className="bg-nude/30 p-8 rounded-3xl text-center border border-beige/50" data-id="element-55">
              <div className="mb-2" data-id="element-56">
                <span className="text-text-brown/60 text-lg" data-id="element-57">
                  Valor normal:{' '}
                </span>
                <PriceDisplay amountARS={49000} strikeThrough className="text-text-brown/60 text-lg" data-id="element-58" />
              </div>
              <div className="mb-6" data-id="element-59">
                <span className="block text-sm font-bold text-accent-rose-deep uppercase tracking-wider mb-2" data-id="element-60">
                  Precio Hoy
                </span>
                <PriceDisplay amountARS={15000} className="text-5xl md:text-6xl font-serif font-bold text-text-dark" data-id="element-61" />
              </div>

              <Button fullWidth className="mb-4" data-id="element-62">
                QUIERO EMPEZAR HOY
              </Button>

              <div className="flex items-center justify-center gap-2 text-sm text-text-brown/60 mt-4" data-id="element-63">
                <Lock className="w-4 h-4" data-id="element-64" />
                <span data-id="element-65">Pago 100% seguro y encriptado</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};